
<div>
  <div class="item-info">
    <span class="single-text-omitted item-name">
      名称：<span
        :title="slotProps?.selectedFile.fullname()"
        v-html="slotProps?.selectedFile.fullname()"
        v-if="!slotProps?.rename.active"
      ></span>
      <input
        class="item-rename-input"
        type="text"
        v-if="slotProps?.rename.value"
        v-model="slotProps.selectedFile.newName"
        ref="renameInputRef"
        v-on:keydown="slotProps?.funs.renameKeydown($event)"
        v-on:blur="slotProps?.funs.renameDone()"
      />
    </span>

    <span class="single-text-omitted item-size">
      大小：<span
        :title="slotProps?.selectedFile.size"
        v-html="slotProps?.selectedFile.size"
      ></span>
    </span>

    <span class="single-text-omitted item-filetype">
      类型：<span
        :title="slotProps?.selectedFile.fileType"
        v-html="slotProps?.selectedFile.fileType"
      ></span>
    </span>
  </div>

  <div
    class="item-loading"
    v-if="slotProps?.loadingShow"
    :style="lodingStyle"
    :title="slotProps.loadingInfo"
  ></div>
</div>
